import React from "react";
import { TransactionHistoryDetailsContainer } from "../../../containers";

const HistoryDetails = (props) => {
  return <TransactionHistoryDetailsContainer {...props} />;
};

export default HistoryDetails;
